export var FeatureModuleEnum;
(function (FeatureModuleEnum) {
    FeatureModuleEnum["EXCHANGE"] = "EXCHANGE";
    FeatureModuleEnum["BANK_WIRE_WITHDRAWAL"] = "BANK_WIRE_WITHDRAWAL";
    FeatureModuleEnum["BANK_WIRE_DEPOSIT"] = "BANK_WIRE_DEPOSIT";
    FeatureModuleEnum["CARD_WITHDRAWAL"] = "CARD_WITHDRAWAL";
    FeatureModuleEnum["CARD_DEPOSIT"] = "CARD_DEPOSIT";
    FeatureModuleEnum["CRYPTO_WITHDRAWAL"] = "CRYPTO_WITHDRAWAL";
    FeatureModuleEnum["CRYPTO_DEPOSIT"] = "CRYPTO_DEPOSIT";
    FeatureModuleEnum["CASH_WITHDRAWAL"] = "CASH_WITHDRAWAL";
    FeatureModuleEnum["CASH_DEPOSIT"] = "CASH_DEPOSIT";
    FeatureModuleEnum["LOANS"] = "LOANS";
    FeatureModuleEnum["STAKING"] = "STAKING";
    FeatureModuleEnum["SMS_2FA"] = "SMS_2FA";
    FeatureModuleEnum["EMAIL_2FA"] = "EMAIL_2FA";
    FeatureModuleEnum["AUTO_CONVERSION"] = "AUTO_CONVERSION";
    FeatureModuleEnum["ACCOUNT_DELETE"] = "ACCOUNT_DELETE";
    FeatureModuleEnum["SWAP"] = "SWAP";
    FeatureModuleEnum["SWAP_SAME_ASSETS"] = "SWAP_SAME_ASSETS";
})(FeatureModuleEnum || (FeatureModuleEnum = {}));
//# sourceMappingURL=feature-module.enum.js.map